/* Polna · strona główna v4: ruch sterowany przewijaniem i drobne interakcje.
   Wzorce z biblioteki (awwwards-design SNIPPETS: parallax image, magnetic button, reveal on scroll, reduced motion),
   kod własny, bez zależności. Jedna pętla rAF uruchamiana przewijaniem. */

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const root = document.documentElement;
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
const clamp01 = (x) => Math.max(0, Math.min(1, x));
root.classList.add('v4');

/* ---------- 5. manifest: słowa i pastylki jako żetony z opacity 0.15 -> 1 ---------- */
const man = $('[data-man]');
let manTokens = [];
if (man) {
  const sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = man.textContent.replace(/\s+/g, ' ').trim();
  const walker = document.createTreeWalker(man, NodeFilter.SHOW_TEXT);
  const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
  for (const tn of nodes) {
    const frag = document.createDocumentFragment();
    for (const part of tn.nodeValue.split(/(\s+)/)) {
      if (!part) continue;
      if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part.includes('\u00a0') ? '\u00a0' : ' ')); continue; }
      const w = document.createElement('span'); w.className = 'man-w'; w.setAttribute('aria-hidden', 'true'); w.textContent = part;
      frag.appendChild(w);
    }
    tn.parentNode.replaceChild(frag, tn);
  }
  man.prepend(sr);
  manTokens = $$('.man-w, .pill', man);
}

/* ---------- 4. magnetyczny „Do koszyka” (tylko precyzyjny wskaźnik, subtelnie) ---------- */
if (fine && !reduced) {
  $$('.card .add').forEach((b) => {
    let r = null;
    b.addEventListener('pointerenter', () => { r = b.getBoundingClientRect(); });
    b.addEventListener('pointermove', (e) => {
      if (!r) r = b.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width / 2) * 0.22, y = (e.clientY - r.top - r.height / 2) * 0.3;
      b.style.setProperty('--mx', `${Math.max(-8, Math.min(8, x)).toFixed(1)}px`);
      b.style.setProperty('--my', `${Math.max(-6, Math.min(6, y)).toFixed(1)}px`);
    });
    b.addEventListener('pointerleave', () => { r = null; b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
  });
}

/* ---------- 2. smooth scroll: własny, lekki (lerp), wzorzec Lenis z biblioteki; bez dotyku i bez reduced-motion ---------- */
const touch = matchMedia('(hover: none), (pointer: coarse)').matches || 'ontouchstart' in window;
const smooth = !reduced && !touch;
let sTarget = scrollY, sCur = scrollY, sRaf = 0, sOwn = false, locked = false;
const maxY = () => document.documentElement.scrollHeight - innerHeight;
let sLast = 0;
const sStep = (t) => {
  // wygładzanie niezależne od częstotliwości odświeżania (0,1 na klatkę przy 60 Hz)
  const dt = sLast ? Math.min(64, t - sLast) : 16.7; sLast = t;
  sCur += (sTarget - sCur) * (1 - Math.pow(0.9, dt / 16.7));
  if (Math.abs(sTarget - sCur) < 0.4) sCur = sTarget;
  sOwn = true; scrollTo(0, sCur);
  sRaf = sCur !== sTarget ? requestAnimationFrame(sStep) : 0; if (!sRaf) sLast = 0;
};
const sGo = (y) => { sTarget = Math.max(0, Math.min(maxY(), y)); if (!sRaf) { sCur = scrollY; sRaf = requestAnimationFrame(sStep); } };
if (smooth) {
  root.classList.add('lenis-on');
  addEventListener('wheel', (e) => {
    if (locked || e.ctrlKey || e.defaultPrevented) return;
    if (e.target.closest && e.target.closest('.drawer, .fmenu, textarea, select')) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    e.preventDefault();
    const d = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaMode === 2 ? e.deltaY * innerHeight : e.deltaY;
    if (!sRaf) sTarget = scrollY;
    sGo(sTarget + d);
  }, { passive: false });
  // przewinięcie z innego źródła (klawiatura, pasek, skrypt): synchronizacja bez walki z użytkownikiem
  addEventListener('scroll', () => { if (sOwn) { sOwn = false; return; } if (sRaf) { cancelAnimationFrame(sRaf); sRaf = 0; } sTarget = sCur = scrollY; }, { passive: true });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]'); if (!a || e.defaultPrevented) return;
    const id = a.getAttribute('href'); if (id.length < 2) return;
    const t = document.querySelector(id); if (!t) return;
    e.preventDefault(); sGo(t.getBoundingClientRect().top + scrollY - 16);
    history.replaceState(null, '', id);
  });
}

/* ---------- 3. menu pełnoekranowe z atramentem z narożnika (ink-corner-reveal, kolor #1E3A2B) ---------- */
const fmenu = $('#fmenu'), menuBtn = $('[data-menu]');
let fx = null, menuOpen = false, closeT = 0;
const inkReady = () => {
  if (fx || !window.InkCornerReveal) return fx;
  try { fx = window.InkCornerReveal.create($('.fmenu-ink', fmenu), { inkColor: [30 / 255, 58 / 255, 43 / 255], paperColor: null, corner: 'tr', edge: 0.03, maxDpr: 1.5, reducedMotion: reduced }); }
  catch (err) { fx = null; }
  return fx;
};
const openMenu = () => {
  if (!fmenu || menuOpen) return;
  menuOpen = true; clearTimeout(closeT);
  fmenu.hidden = false; fmenu.classList.remove('is-closing');
  root.classList.add('menu-lock'); locked = true;
  menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
  const f = inkReady();
  if (f) f.to('full', reduced ? 0.001 : 1.0); else fmenu.style.background = 'var(--green)';
  requestAnimationFrame(() => requestAnimationFrame(() => fmenu.classList.add('is-open')));
  setTimeout(() => { const c = $('.fmenu-close', fmenu); c && c.focus({ preventScroll: true }); }, reduced ? 0 : 400);
};
const closeMenu = (focusBack = true) => {
  if (!fmenu || !menuOpen) return;
  menuOpen = false;
  fmenu.classList.remove('is-open'); fmenu.classList.add('is-closing');
  menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
  closeT = setTimeout(() => { if (fx) fx.to('rest', reduced ? 0.001 : 0.7); }, reduced ? 0 : 220);
  setTimeout(() => { if (!menuOpen) { fmenu.hidden = true; fmenu.classList.remove('is-closing'); root.classList.remove('menu-lock'); locked = false; sTarget = sCur = scrollY; } }, reduced ? 0 : 1000);
  if (focusBack && menuBtn) menuBtn.focus({ preventScroll: true });
};
if (fmenu) {
  menuBtn && menuBtn.addEventListener('click', () => (menuOpen ? closeMenu() : openMenu()));
  $('[data-menu-close]', fmenu).addEventListener('click', () => closeMenu());
  $$('.fmenu-links a, .fmenu-foot a[href^="#"]', fmenu).forEach((a) => a.addEventListener('click', () => closeMenu(false)));
  document.addEventListener('keydown', (e) => {
    if (!menuOpen) return;
    if (e.key === 'Escape') closeMenu();
    if (e.key === 'Tab') { // pułapka fokusu w dialogu
      const f = $$('a, button', fmenu); const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  addEventListener('resize', () => { if (menuOpen && innerWidth > 900 && !window.__menuDemo) closeMenu(false); });
  window.__polnaMenu = { open: openMenu, close: closeMenu };
}

/* ---------- 6. Dzień z Polną: licznik, godzina i miejsce ---------- */
const day = $('[data-day]');
const dayItems = day ? $$('.day-item', day) : [];
const dayImgs = dayItems.map((li) => $('.day-img', li));
const dayNum = $('[data-day-num]'), dayCap = $('[data-day-cap]'), dayVp = $('[data-day-viewport]');
const caps = dayItems.map((li) => { const t = ($('figcaption', li)?.textContent || '').split(','); return `${(t[1] || '').trim()} · ${t[0].trim()}`; });
let dayIdx = -1;
const setDay = (i) => {
  if (i === dayIdx || !dayNum) return; dayIdx = i;
  dayNum.textContent = String(i + 1).padStart(2, '0'); dayCap.textContent = caps[i];
  if (!reduced) { dayNum.classList.remove('tick'); void dayNum.offsetWidth; dayNum.classList.add('tick'); }
};
if (dayVp) dayVp.addEventListener('scroll', () => req(), { passive: true });
setDay(0);

/* ---------- 7. cechy: aktywna ta najbliżej środka ekranu ---------- */
const feats = $$('[data-feats] .feat-v4');
const whyWide = matchMedia('(min-width: 901px)');
/* poprawki 08.10: jeden punkt odniesienia = środek przypiętej ryciny (top sticky + połowa wysokości).
   Odstęp nad cechą 1 i pod ostatnią cechą liczony tak, by cecha 1 stała na wysokości środka ryciny od chwili
   przypięcia, a rycina odklejała się dopiero, gdy środek ostatniej cechy dojdzie do jej środka. */
const whyArt = $('.why-v4 .why-art');
const featsList = $('[data-feats]');
const whyRef = () => (whyArt && whyWide.matches ? (parseFloat(getComputedStyle(whyArt).top) || 0) + whyArt.offsetHeight / 2 : innerHeight * 0.5);
const whyFit = () => {
  if (!featsList || !whyArt || !feats.length) return;
  if (!whyWide.matches) { featsList.style.paddingTop = ''; featsList.style.paddingBottom = ''; return; }
  const half = whyArt.offsetHeight / 2;
  featsList.style.paddingTop = `${Math.max(0, Math.round(half - feats[0].offsetHeight / 2))}px`;
  featsList.style.paddingBottom = `${Math.max(0, Math.round(half - feats[feats.length - 1].offsetHeight / 2))}px`;
};
whyFit();
addEventListener('load', whyFit);
if (document.fonts) document.fonts.ready.then(whyFit);
if (window.ResizeObserver && whyArt && feats.length) { const ro = new ResizeObserver(() => whyFit()); ro.observe(whyArt); ro.observe(feats[0]); ro.observe(feats[feats.length - 1]); }

/* ---------- 9. przerywniki: rozszerzanie clip-path od środka + paralaksa ---------- */
const expands = $$('[data-expand]');

/* ---------- 13. przejścia koloru tła ---------- */
const zones = $$('[data-bg]');
const bgfx = $('.bgfx');
if (!reduced && bgfx) root.classList.add('v4-bg');

/* ---------- 10. subskrypcja: licznik ceny i tekstu ---------- */
const subForm = $('[data-sub-form]');
if (subForm) {
  const F = { 28: 13 }; // co 28 dni: 13 tomów w roku
  const els = { n: $('[data-sub-n]'), t: $('[data-sub-tomy]'), save: $('[data-sub-save]'), btn: $('[data-sub-btn]') };
  const cur = { n: 13, save: 13 * Number(subForm.dataset.save || 0) };
  let raf = 0;
  const tomy = (n) => (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'tomy' : 'tomów');
  const run = (f) => {
    const P = Number(subForm.dataset.price || 0), S = Number(subForm.dataset.save || 0);
    const to = { n: F[f], save: F[f] * S }, from = { ...cur }, t0 = performance.now(), D = reduced ? 0 : 650;
    cancelAnimationFrame(raf);
    const st = (t) => {
      const k = D ? Math.min(1, (t - t0) / D) : 1, e = 1 - Math.pow(1 - k, 3);
      for (const key of ['n', 'save']) { cur[key] = Math.round(from[key] + (to[key] - from[key]) * e); if (els[key]) els[key].textContent = cur[key].toLocaleString('pl-PL'); }
      if (els.t) els.t.textContent = tomy(cur.n);
      if (k < 1) raf = requestAnimationFrame(st);
    };
    raf = requestAnimationFrame(st);
    const yr = Math.round(F[f] * S), txt = (subForm.dataset.btn || 'Subskrybuj i oszczędź {save} zł w ciągu roku').replace('{n}', f).replace('{price}', P).replace('{save}', yr.toLocaleString('pl-PL'));
    if (reduced) { els.btn.textContent = txt; return; }
    els.btn.classList.add('swap'); setTimeout(() => { els.btn.textContent = txt; els.btn.classList.remove('swap'); }, 200);
  };
  subForm.addEventListener('change', (e) => { if (e.target.name === 'freq') run(e.target.value); });
}

/* ---------- wejścia jednorazowe: konik (obrót max 3°), prezent (clip-path) ---------- */
const once = new IntersectionObserver((es) => es.forEach((e) => {
  if (!e.isIntersecting) return;
  e.target.classList.add(e.target.classList.contains('sub-plane') ? 'is-turn' : 'is-open'); once.unobserve(e.target);
}), { threshold: 0.25 });
$$('.sub-plane, [data-gift-clip]').forEach((el) => (reduced ? el.classList.add(el.classList.contains('sub-plane') ? 'is-turn' : 'is-open') : once.observe(el)));

/* ---------- pętla przewijania ---------- */
const cards = $$('.card-media');
let vh = innerHeight;

const update = () => {
  ticking = false;
  const mid = vh * 0.5;
  // 6. licznik galerii (także przy reduced-motion) + skalowanie kadru w centrum
  if (dayItems.length) {
    const dr = day.getBoundingClientRect();
    if (dr.bottom > 0 && dr.top < vh) {
      const cx = innerWidth / 2; let best = 0, bd = 1e9;
      dayItems.forEach((li, i) => {
        const r = li.getBoundingClientRect(); const c = r.left + r.width / 2; const d = Math.abs(c - cx);
        if (d < bd) { bd = d; best = i; }
        if (!reduced && innerWidth > 760) {
          const k = clamp01(1 - d / (innerWidth * 0.75));
          dayImgs[i].style.setProperty('--ds', (0.9 + 0.1 * k).toFixed(4));
          dayImgs[i].style.setProperty('--dz', (1.08 - 0.08 * k).toFixed(4));
        }
      });
      setDay(best);
    }
  }
  if (reduced) return;
  // 4. paralaksa obrazu wewnątrz ramki karty: od +14 px do -14 px
  for (const m of cards) {
    const r = m.getBoundingClientRect();
    if (r.bottom < -50 || r.top > vh + 50) continue;
    const p = clamp01((vh - r.top) / (vh + r.height));
    m.style.setProperty('--py', `${((0.5 - p) * 28).toFixed(1)}px`);
  }
  // 5. manifest: postęp od wejścia sekcji (góra przy 85% ekranu) do 35% ekranu
  if (man) {
    const r = man.getBoundingClientRect();
    if (r.bottom > 0 && r.top < vh) {
      const p = clamp01((vh * 0.85 - r.top) / (vh * 0.85 - vh * 0.35 + r.height * 0.5));
      const n = manTokens.length;
      manTokens.forEach((t, i) => {
        const k = clamp01(p * (n + 1) - i);
        t.style.setProperty('--o', (0.15 + 0.85 * k).toFixed(3));
        if (t.classList.contains('pill')) t.style.setProperty('--s', (0.8 + 0.2 * k).toFixed(3));
      });
    }
  }
  // 7. aktywna cecha
  if (feats.length && whyWide.matches) {
    let best = -1, bd = 1e9; const ref = whyRef();
    feats.forEach((f, i) => { const r = f.getBoundingClientRect(); const d = Math.abs(r.top + r.height / 2 - ref); if (d < bd) { bd = d; best = i; } });
    feats.forEach((f, i) => f.classList.toggle('is-active', i === best));
  }
  // 9. przerywniki: inset od środka 14%/20% -> 0 przy wejściu, potem paralaksa obrazu
  for (const el of expands) {
    const r = el.getBoundingClientRect();
    if (r.bottom < -50 || r.top > vh + 50) continue;
    const p = clamp01((vh - r.top) / (vh * 0.85));
    const e = 1 - Math.pow(1 - p, 2);
    el.style.setProperty('--ey', `${(14 * (1 - e)).toFixed(2)}%`);
    el.style.setProperty('--ex', `${(20 * (1 - e)).toFixed(2)}%`);
    el.style.setProperty('--er', `${(14 * (1 - e)).toFixed(1)}px`);
    const q = clamp01((vh - r.top) / (vh + r.height));
    const img = el.querySelector('img'); if (img) img.style.setProperty('--ty', `${((0.5 - q) * 56).toFixed(1)}px`);
  }
  // 13. tło (poprawki 08.10): kolor niosą same sekcje (ostre cięcie na krawędzi), warstwy .bgfx zostają wygaszone,
  //     więc nie ma stanów pośrednich (szarozielony, brudny róż, brąz) i tekst ma pełną widoczność (--ink-o = 1).
  if (bgfx && (bgfx.style.getPropertyValue('--bg-g') !== '0' || bgfx.style.getPropertyValue('--bg-b') !== '0')) {
    bgfx.style.setProperty('--bg-g', '0'); bgfx.style.setProperty('--bg-b', '0');
  }
};

let ticking = false;
const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
addEventListener('scroll', req, { passive: true });
addEventListener('resize', () => { vh = innerHeight; whyFit(); req(); });
addEventListener('load', req);
update();
